import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { BreadcrumbItemModel } from './models';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbsComponent {
  @Input() items: BreadcrumbItemModel[];

  constructor() {}
}
